export * from '@primeuix/themes/aura/confirmdialog';
export { default } from '@primeuix/themes/aura/confirmdialog';
